import SLPInfluencersHow1 from '../../assets/slpInfluencers/slpInfluencersHow1.png';
import SLPInfluencersHow2 from '../../assets/slpInfluencers/slpInfluencersHow2.png';
import SLPInfluencersHow3 from '../../assets/slpInfluencers/slpInfluencersHow3.png';
import SLPInfluencersHow4 from '../../assets/slpInfluencers/slpInfluencersHow4.png';
import SLPInfluencersHow5 from '../../assets/slpInfluencers/slpInfluencersHow5.png';
import SLPInfluencersListPersonaBtn from './SLPInfluencersListPersonaBtn';
import * as CommonSectionTypes from '../components/CommonSectionLayout/CommonSectionTypes';
import CommonSectionGenerator from '../components/CommonSectionLayout/CommonSectionGenerator';

const subSection1: CommonSectionTypes.SubSection =
{
  heading: 'Create Your Profile',
  description: 'Add your bio, social media details and high-quality portfolio pictures of yourself.',
  images: [SLPInfluencersHow1]
};

const subSection2: CommonSectionTypes.SubSection =
{
  heading: 'Set Your Fee. Enable Payouts.',
  description: 'Choose how much brands pay to use your Persona each month. Connect your Stripe account to receive payouts securely and on your terms.',
  images: [SLPInfluencersHow2]
};

const subSection3: CommonSectionTypes.SubSection =
{
  heading: 'Publish to the FairEx - Influencer Marketplace',
  description: 'Your Persona becomes visible to agencies and brands looking for Personas to feature.',
  images: [SLPInfluencersHow3]
};

const subSection4: CommonSectionTypes.SubSection =
{
  heading: 'Review & Approve Requests',
  description: 'Approve or decline each request.  Nothing is published having your Persona without your consent.',
  images: [SLPInfluencersHow4]
};

const subSection5: CommonSectionTypes.SubSection =
{
  heading: 'Get Paid and Track Attribution',
  description: 'Earn from every licensed use, with full transparency and royalty tracking. Content Credential metadata keeps your name and license information on every image.',
  images: [SLPInfluencersHow5]
};

const slpInfluencersHowData: CommonSectionTypes.Section =
{
  heading: 'How it Works',
  subheading: 'List, License, Earn',
  subsections: [subSection1, subSection2, subSection3, subSection4, subSection5]
};

export const SLPInfluencersHow = () =>
{
  return CommonSectionGenerator(slpInfluencersHowData, SLPInfluencersListPersonaBtn, '#000000');
};
